__turbopack_context__.v({
  "container": "live-games-container-module-sass-module__IH6ija__container",
  "sidebar": "live-games-container-module-sass-module__IH6ija__sidebar",
});
